import { createContext, useContext } from 'react'
import type { Me } from '@/api/types'

export type SignOutReason = 'expired' | 'signed_out' | null

export interface AuthContextValue {
  user: Me | null
  /** Why the last session ended; shown on the login page. */
  signOutReason: SignOutReason
  login: (email: string, password: string) => Promise<Me>
  /**
   * Store a session that another flow already obtained (the invite page:
   * sign in, then claim; or accept). Throws ApiError 403 not_super_admin,
   * storing nothing, unless `me` is a super-admin.
   */
  adoptSession: (token: string, me: Me) => void
  logout: (reason?: Exclude<SignOutReason, null>) => void
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined)

export const NOT_SUPER_ADMIN_MESSAGE =
  "This console is for ScoreLM super-admins. League admins sign in on their league's own site."

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used inside <AuthProvider>')
  return ctx
}
